import { css } from 'lit';

export const style = css`
    :host {
        --slider-control-button__bg--focus: var(--_slider-control-button__bg--focus , var(--sbkSliderControlBgColorOnLightActive));
        --slider-control-button__color--focus: var(--_slider-control-button__color--focus , var(--sbkSliderControlFgColorOnDarkHover));
        --slider-control-button__border--focus: var(--_slider-control-button__border--focus , var(--sbkSliderControlBorderOnLightFocus));
        
        --slider-control-button__border--active: var(--_slider-control-button__border-color--active, var(--sbkSliderControlBorderOnLightActive));
        --slider-control-button__bg--active: var(--_slider-control-button__bg--active , var(--sbkSliderControlBgColorOnLightActive));
        --slider-control-button__color--active: var(--_slider-control-button__color--active, var(--sbkSliderControlFgColorOnDarkHover));

        --slider-control-button__border--disabled: var(--_slider-control-button__border-color--disabled, var(--sbkSliderControlBorderOnLightDisabled));
        --slider-control-button__bg--disabled: var(--_slider-control-button__bg--disabled , var(--sbkSliderControlBgColorOnLightDisabled));
        --slider-control-button__color--disabled: var(--_slider-control-button__color--disabled, var(--sbkSliderControlFgColorOnLightDisabled));

        --slider-control-button__bg--hover: var(--_slider-control-button__bg--hover , var(--sbkSliderControlBgColorOnLightHover));
        --slider-control-button__color--hover: var(--_slider-control-button__color--hover, var(--sbkSliderControlFgColorOnLightHover));
        --slider-control-button__border--hover: var(--_slider-control-button__border--hover, var(--sbkSliderControlBorderOnLightHover));

        --slider-control-button__color: var(--_slider-control-button__color, var(--sbkSliderControlFgColorOnLightEnabled));
        --slider-control-button__bg: var(--_slider-control-button__bg , var(--sbkSliderControlBgColorOnLightEnabled));
        --slider-control-button__border: var(--_slider-control-button__border , var(--sbkSliderControlBorderOnLightEnabled));
        
        --slider-control__color: var(--_slider-control__color , var(--sbkSliderControlFgColorOnLightEnabled));
    }
    
  .slider-control {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--sbkSliderControlSpacingGap);
  }
    
    .slider-control-button {
        height: var(--sbkSliderControlSizingMaxHeightButton);
        width: var(--sbkSliderControlSizingMaxHeightButton);
        border: var(--slider-control-button__border);
        border-radius: var(--sbkRoundButtonBorderRadiusBorderRadiusDefault);
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        outline: 2px solid transparent;
        outline-offset: var(--sbkRoundButtonBorderRadiusBorderGapFocus);
        background-color: var(--slider-control-button__bg);
        color: var(--slider-control-button__color);
    }

    @media (hover: hover) and (pointer: fine) {
        .slider-control-button:hover {
            background-color: var(--slider-control-button__bg--hover);
            border: var(--slider-control-button__border--hover);
            color: var(--slider-control-button__color--hover);
        }
    }
    
    .slider-control-button:focus-visible:not(:active) {
        outline: var(--slider-control-button__border--focus);
        background-color: var(--slider-control-button__bg--focus);
        border: var(--slider-control-button__border--active);
        color: var(--slider-control-button__color--focus);
    }
    
    .slider-control-button:active {
        background-color: var(--slider-control-button__bg--active);
        border: var(--slider-control-button__border--active);
        color: var(--slider-control-button__color--active);
    }

    .slider-control-button[disabled] {
        cursor: not-allowed;
        background-color: var(--slider-control-button__bg--disabled);
        border: var(--slider-control-button__border--disabled);
        color: var(--slider-control-button__color--disabled);
    }

   .indicators {
       display: flex;
       gap: var(--sbkSliderControlSpacingGapText);
       font: var(--sbkSliderControlText);
       color: var(--slider-control__color);
   }
    
    .current {
        font: var(--sbkSliderControlTextCurrentSlide);
    }
`;